export const FLIGHT_LEG_PHASE_START = 'start';
export const FLIGHT_LEG_PHASE_FINISH = 'end';
export function isLegFinished(leg) {
    return (leg === null || leg === void 0 ? void 0 : leg.phase) === FLIGHT_LEG_PHASE_FINISH;
}
//# sourceMappingURL=legPhase.js.map